import { createAction } from "@reduxjs/toolkit";
import { actionRequest } from "../helper";

export const actions = {
    GET_USER_BASIC_PROFILE: "GET_USER_BASIC_PROFILE",
};

export const getUserBasicProfile = createAction(
    actionRequest(actions.GET_USER_BASIC_PROFILE)
  )